import { taskCategoriesSlice } from "./taskCategoriesSlice";
import * as defaultActions from "../../../../../redux/_common";
import * as constants from "./constants";
import { Dispatch } from "redux";
import { get } from "../../../../../api/requester";

export const QPARAMS_CHANGED = "taskCategories/QParamsChanged";
const { actions } = taskCategoriesSlice;

export const setValidationErrors = actions.setValidationErrors;

const moduleUrl = '/api/activity/taskcategories'

export const getTaskCategoryTypes = () => async (dispatch:Dispatch) => {
  try {
    dispatch(actions.setTaskCategoryTypesLoading(true))
    const res = await get('/api/activity/tasktypes/select')
    dispatch(actions.setTaskCategoryTypes(res))
  } catch (e) {

  } finally {
    dispatch(actions.setTaskCategoryTypesLoading(false))
  }
}

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
